
// For debug purposes only
import env from '../env'
import { KENV } from '../types/admin'
import { VolumeInterpolation } from '@/classes/VolumeInterpolation'

function logParameters (e) {
  const clickedElement = e.target
  const videoPlayerElement = clickedElement.closest(".video-player")
  if (!clickedElement || !videoPlayerElement) {
    // console.log('Did you click on a video player?')
    return
  }

  const maskElement = clickedElement.closest(".content-mask")
  const rect = videoPlayerElement.getBoundingClientRect()
  const stretchContent = !!maskElement && !!maskElement.getAttribute('data-stretchcontent')
  const maskRect = (stretchContent && maskElement) ? maskElement.getBoundingClientRect() : rect

  console.log('_ videoPlayer %s ____________', videoPlayerElement.id)
  console.log('| stretchContent', stretchContent)
  console.log('| rect', rect)
  console.log('| maskRect', maskRect)
  console.log('| maskElement', maskElement)
  console.log('| videoPlayerElement', videoPlayerElement)
  console.log('__________________________')
}

// Speed with which the volumes are adjusted, in volume "units" per second
const volumeChangeSpeed = 1
const volumeInterpolation = new VolumeInterpolation(volumeChangeSpeed)

interface SinkAttributes {
  sinkid: string
  top: number
  right: number
  bottom: number
  left: number,
  width: number,
  height: number,
  alpha: number,
  volume: string,
  clipmute: number,
  zorder?: number,
  ovolume?: string|null,
  cs?: string|null,
  cw?: string|null,
  cb?: string|null,
  cbl?: string|null,
  cwh?: string|null
}

interface DebugElement {
  element: Element,
  maskElement: Element|null,
  opacityElement: HTMLElement,
  opacity: number,
  stretchContent: boolean
}

type StepAnimation = (framenr: number) => {}
export class CefTimestamp {
  debugMode: boolean = false
  externalre: string = 'Pre'
  lastts: number = 0
  lastfnr: number = 0
  lastprinttimestamp: number|null = null
  last_data = { }
  loopSpeed: number = 0

  constructor (paramLoopSpeed: number, debugMode: boolean) {
    this.debugMode = debugMode
    this.ngcvpRenderLoop(null)
    this.loopSpeed = paramLoopSpeed
    if (this.debugMode) {
      document.onclick = logParameters
    }
  }

  ngcvpRenderLoop (stepanimation: StepAnimation | null) {
    if (stepanimation) {
      stepanimation(this.lastfnr)
    }
    const embeddedTimestamp = document.getElementById('embedded_timestamp')
    if (embeddedTimestamp === undefined || embeddedTimestamp === null) {
      setTimeout(() => { this.ngcvpRenderLoop(null) }, this.loopSpeed)
      return
    }
    embeddedTimestamp.style.backgroundColor = '#' + ('000000' + this.lastfnr.toString(16)).substr(-6)
    const timestamp = Math.round((new Date()).getTime())
    const dt = timestamp - this.lastts
    this.lastts = timestamp
    this.lastfnr += 1
    const data = {
      timestamp: timestamp,
      dt: dt,
      embedded_timestamp: embeddedTimestamp.style.backgroundColor.toString(),
      lastfnr: this.lastfnr,
      sinks: {}
    }
    const elements = document.getElementsByClassName('ngcvp-sink')
    const debugElements: DebugElement[] = []
    for (let idx = 0; idx < elements.length; ++idx) {
      const element = elements[idx]
      const rect = element.getBoundingClientRect()
      const maskElement = element.closest(".content-mask")
      const opacityElement = (element.closest(".cef-opacity") || element) as HTMLElement
      const stretchContent = !!maskElement && !!maskElement.getAttribute('data-stretchcontent')

      let alpha = 0
      alpha = Number(window.getComputedStyle(opacityElement).getPropertyValue('opacity'))
      if (opacityElement.style.opacity !== '') {
        alpha = Number(opacityElement.style.opacity)
      }
      const requestedVolume = parseFloat(element.getAttribute('volume') ?? '0')
      let volume = volumeInterpolation.getVolume({ id: element.id, volume: requestedVolume})
      const muted = element.getAttribute('sinkMuted') === "true"
      if (muted) volume = 0
      let sink: SinkAttributes = {
        sinkid: element.id,
        top: Math.round(rect.top),
        right: Math.round(rect.right),
        bottom: Math.round(rect.bottom),
        left: Math.round(rect.left),
        width: Math.round(rect.width),
        height: Math.round(rect.height),
        alpha: alpha,
        volume: `${volume}`,
        clipmute: element.classList.contains('cef-clipmute') ? 1 : 0,
      }
      const parentNode = opacityElement.parentNode as HTMLElement|null
      if (opacityElement.style['z-index'] !== '') {
        // TODO Remove this when layout editor is setting zindexes properly
        sink.zorder = parseInt(opacityElement.style['z-index']) + 1
      } else if (parentNode !== null && parentNode.style['z-index'] !== '') {
        sink.zorder = parseInt(parentNode.style['z-index']) + 1
      }
      if (element.getAttribute('overwrite_volume') !== null && element.getAttribute('overwrite_volume') !== "") {
        sink.ovolume = element.getAttribute('overwrite_volume')
      }
      const chromaWeight = element.getAttribute('chromakey_weight')
      if (chromaWeight !== null && parseFloat(chromaWeight) > 0) {
        sink.cs = element.getAttribute('chromakey_screen')
        sink.cw = element.getAttribute('chromakey_weight')
        sink.cb = element.getAttribute('chromakey_balance')
        sink.cbl = element.getAttribute('chromakey_clipblack')
        sink.cwh = element.getAttribute('chromakey_clipwhite')
      } else {
        sink.cw = "0"
      }

      // Cropping support
      // this is the visible part on screen (= mask)
      // if no cropping this should be extremely similar to the other rectangle

      // ALWAYS send a mask Rectangle
      const maskRect = ((stretchContent === true) && maskElement) ? maskElement.getBoundingClientRect() : rect
      const cropData = {
        mask_top: Math.round(maskRect.top),
        mask_right: Math.round(maskRect.right),
        mask_bottom: Math.round(maskRect.bottom),
        mask_left: Math.round(maskRect.left),
        mask_width: Math.round(maskRect.width),
        mask_height: Math.round(maskRect.height),
        stretchcontent: stretchContent
      }
      // console.log(stretchContent)

      let cropdir = 'portrait'
      if (cropData.mask_width < cropData.mask_height * 16.0 / 9.0) {
        cropdir = 'landscape'
      }

      if (maskElement) {
        if (maskElement.getAttribute('data-stretchcontentalign')) {
          sink.left = Math.round(cropData.mask_left);
          sink.top = Math.round(cropData.mask_top);
          sink.width = Math.round(cropData.mask_width);
          sink.height = Math.round(cropData.mask_height);

          if (cropdir === 'portrait') {
            sink.height = Math.round(sink.width  * 9.0 / 16.0)
          } else {
            sink.width = Math.round(sink.height  * 16.0 / 9.0)
          }
        }
        if (maskElement.getAttribute('data-stretchcontentalign') === 'flex-end') {
          if (cropdir === 'portrait') {
            sink.top = Math.round(cropData.mask_bottom - sink.height)
          } else {
            sink.left = Math.round(cropData.mask_right - sink.width)
          }
        }
        if (maskElement.getAttribute('data-stretchcontentalign') === 'center') {
          if (cropdir === 'portrait') {
            sink.top = Math.round(cropData.mask_top + (cropData.mask_height - sink.height) / 2.0)
          } else {
            sink.left = Math.round(cropData.mask_left + (cropData.mask_width - sink.width) / 2.0)
          }
        }
        // console.log('maskElement ' + maskElement.getAttribute('data-stretchcontentalign'))
      }

      // add prefix
      sink = {
        ...sink,
        ...cropData
      }

      data.sinks[element.id] = sink

      if (this.debugMode) {
        debugElements.push({
          element: element,
          maskElement: maskElement,
          opacityElement: opacityElement,
          opacity: alpha,
          stretchContent: stretchContent
        })
      }
    }

    // DEBUG ONLY
    // @ts-ignore
    if (this.debugMode && !window.firstRun) {
      // show debug info once
      console.clear()
      console.log('cef init data ', data)

      debugElements.forEach(d => {
        console.log('-------------------------------------------')
        if (d.stretchContent) {
          console.log('USE MASK and stretchContent', d.element)
        } else {
          console.log('NO MASK', d.element)
        }

        console.log('opacity', d.opacity)
        console.log(d)
      })
      // @ts-ignore
      window.firstRun = true
    }

    try {
      // this is the old/depricated style cef callback here for backward compatibility for a bit
      // @ts-ignore
      external.py_callback(data)
    } catch (e) {
      try {
        // this is the new style cef callback
        // @ts-ignore
        window.cefQuery({request: JSON.stringify(data)});
    } catch (e) {
        // no need to overflow console.log in dev environment
        if (env.environment !== KENV.Dev) {
          console.log(data)
        }
      }
    }
    setTimeout(() => { this.ngcvpRenderLoop(null) }, this.loopSpeed)
  }
}

export default CefTimestamp
